export default defineNuxtPlugin(() => {
  const { initInstallPrompt } = usePwaInstall();
  initInstallPrompt();

  if ('serviceWorker' in navigator) {
    const swUpdating = useState('swUpdating', () => false);

    // Show overlay when a SW update is detected, reload when new SW takes control.
    // refreshing flag prevents double reload if controllerchange fires multiple times.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      if (!swUpdating.value) return; // first install: no overlay was shown → skip reload
      refreshing = true;
      window.location.reload();
    });

    // Detect update vs. first install:
    // At 'installed' state, navigator.serviceWorker.controller is the OLD SW (still in control).
    // If it's set → this is an update → show overlay.
    // If it's null → first install → skip overlay (controllerchange will still fire but no overlay shown).
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (!registration) return;

      const onUpdateFound = () => {
        // controller is the OLD SW still in control at this point.
        // If set → update (not first install) → show overlay immediately.
        if (navigator.serviceWorker.controller) {
          swUpdating.value = true;
        }
      };

      registration.addEventListener('updatefound', onUpdateFound);

      // Race condition: new SW may already be installing before we added the listener
      if (registration.installing && navigator.serviceWorker.controller) {
        swUpdating.value = true;
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        navigator.serviceWorker.getRegistration().then((registration) => {
          registration?.update();
        });
      }
    });

    setInterval(() => {
      navigator.serviceWorker.getRegistration().then((registration) => {
        registration?.update();
      });
    }, 60_000);
  }
});
